module.exports = __webpack_public_path__ + "static/media/mujer-hombre4.259e793e.jpg";